export const SEARCH_OPTION_TYPE = {
  TYPE: "types",
  TAG: "tags",
  MEMBER: "members",
} as const;

export const SEARCH_OPTION_SECTION = {
  MEDIA_ITEM: "media_item",
  EXPERIENCE: "experience",
  VISUAL_BUILDER: "visual_builder",
} as const;
